import React from 'react';
import Typography from '@mui/material/Typography';

const Copyright: React.FC = () => (
  <Typography variant="body2" color="text.secondary" align="center">
    © 2024 Mitani Corp. みてリンク
  </Typography>
);

export default Copyright;
